// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-M1":"M1_outdoor-recreation-M1__6YO6j"};